import { render, staticRenderFns } from "./message-bubble.vue?vue&type=template&id=6841406c&scoped=true"
import script from "./message-bubble.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-bubble.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./message-bubble.vue?vue&type=style&index=0&id=6841406c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6841406c",
  null
  
)

export default component.exports